export default __webpack_public_path__ + "static/media/booking-main-good.72ea0c2d.svg";